"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledInputConfig = exports.config = void 0;
var _Check = _interopRequireDefault(require("@tvg/fuse-icons/lib/Check"));
var _Error = _interopRequireDefault(require("@tvg/fuse-icons/lib/Error"));
var _Visibility = _interopRequireDefault(require("@tvg/fuse-icons/lib/Visibility"));
var _VisibilityOff = _interopRequireDefault(require("@tvg/fuse-icons/lib/VisibilityOff"));
var _fuseUtils = require("@tvg/fuse-utils");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var config = exports.config = {
  componentName: 'fuse-input-field',
  icon: {
    error: {
      state: /*#__PURE__*/_react["default"].createElement(_Error["default"], null),
      label: 'Input filled incorrectly'
    },
    success: {
      state: /*#__PURE__*/_react["default"].createElement(_Check["default"], null),
      label: 'Input filled correctly'
    },
    size: 'small'
  },
  leading: {
    pound: '£',
    euro: '€'
  },
  maskIconButton: {
    hideIcon: /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], null),
    hideIconSrLabel: function hideIconSrLabel(label) {
      return "Hide ".concat(label);
    },
    hideIconClassName: "fuse-input__mask-input-button--hide",
    showIcon: /*#__PURE__*/_react["default"].createElement(_Visibility["default"], null),
    showIconSrLabel: function showIconSrLabel(label) {
      return "Show ".concat(label);
    },
    showIconClassName: "fuse-input__mask-input-button--show"
  }
};
var styledInputConfig = exports.styledInputConfig = {
  borderColor: {
    error: 'var(--color-functional-errorMid)',
    success: 'var(--color-functional-successMid)',
    completed: 'var(--color-greys-grey7)'
  },
  borderRadius: (0, _fuseUtils.BorderRadiusCss)('l'),
  borderWidth: '1px',
  componentName: config.componentName,
  maskIconButton: {
    color: 'var(--color-global-grey800)',
    size: 'small'
  },
  helperTextColor: {
    error: 'var(--color-functional-errorMid)',
    success: 'var(--color-global-grey800)'
  }
};